import { render } from "./gallery-pop-layout.vue?vue&type=template&id=f661d62e"
import script from "./gallery-pop-layout.vue?vue&type=script&lang=js"
export * from "./gallery-pop-layout.vue?vue&type=script&lang=js"

import "./gallery-pop-layout.vue?vue&type=style&index=0&id=f661d62e&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-detail-info/gallery-pop-layout.vue'],['render',render],['__file',"gallery-pop-layout.vue"]])

export default __exports__